import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { getWithAuth } from "../../api/api";
import { API_URLS } from "../../api/apiConfig";
import dayjs from "dayjs";

const ModalCleaningHistory = ({ onClose, cleaning_id }) => {
  const [records, setRecords] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const current = records[currentIndex] || {};

  const FIELD_LABELS = {
    date_cleaning: "Fecha de limpieza",
    cleaning_type: "Tipo de limpieza",
    is_forced: "¿Forzada?",
    booking_external_id: "ID de Reserva",
  };

  const formatTimestamp = (timestampStr) => {
    return dayjs(timestampStr).format("DD/MM/YYYY HH:mm");
  };

  const getActionLabel = (action) => {
    switch (action) {
      case "create":
        return "Creación";
      case "update":
        return "Actualización";
      case "delete":
        return "Eliminación";
      case "read":
        return "Consulta";
      default:
        return "Desconocida";
    }
  };

  const formatDate = (dateStr) => dateStr?.split("T")[0] || "-";

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await getWithAuth(
          API_URLS.GET_CLEANING_HISTORY(cleaning_id)
        );
        if (res.message === "success") {
          setRecords(res.data);
        }
      } catch (error) {
        console.error("Error al obtener el historial de la limpieza", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [cleaning_id]);

  const cleaning = current.new_document || {};

  return (
    <Modal show={true} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Historial de Limpieza{" "}
          {records.length > 0
            ? `Versión ${currentIndex + 1} de ${records.length}`
            : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "20vh" }}
          >
            <div className="spinner-border text-warning" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        ) : records.length === 0 ? (
          <div className="text-center">No hay historial disponible.</div>
        ) : (
          <div className="modal-body py-5 px-lg-17">
            <div className="mb-4">
              <p>
                <strong>Acción:</strong> {getActionLabel(current.action)}
              </p>
              <p>
                <strong>Fecha:</strong> {formatTimestamp(current.timestamp)}
              </p>
              <p>
                <strong>Modificado por:</strong>{" "}
                {current.performed_by?.email || "Desconocido"}
              </p>
            </div>

            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Fecha de limpieza</Form.Label>
                <Form.Control
                  type="date"
                  readOnly
                  value={formatDate(cleaning.date_cleaning)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Tipo de limpieza</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  value={cleaning.cleaning_type || ""}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>¿Forzada?</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  value={cleaning.is_forced ? "Sí" : "No"}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>ID de Reserva</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  value={cleaning.booking_external_id || ""}
                />
              </Form.Group>
            </Form>

            {current.changes && (
              <div className="mt-5">
                <h5 className="mb-3">Cambios realizados:</h5>
                {Object.entries(current.changes).map(([field, change]) => {
                  const formatValue = (value) => {
                    if (typeof value === "boolean") {
                      return value ? "Sí" : "No";
                    }
                    if (value === null || value === undefined) {
                      return "—";
                    }
                    return String(value);
                  };

                  return (
                    <div
                      key={field}
                      className="mb-4 ps-3 border-start border-3 border-warning"
                    >
                      <div className="fw-bold text-capitalize">
                        {FIELD_LABELS[field] || field.replace(/_/g, " ")}
                      </div>
                      <div className="text-muted ms-2">
                        <div>
                          <strong>Anterior:</strong> {formatValue(change?.from)}
                        </div>
                        <div>
                          <strong>Actual:</strong> {formatValue(change?.to)}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      {records.length > 0 && (
        <Modal.Footer className="justify-content-between">
          <Button
            variant="secondary"
            onClick={() => setCurrentIndex(Math.max(currentIndex - 1, 0))}
            disabled={currentIndex === 0}
          >
            Anterior
          </Button>
          <Button
            variant="secondary"
            onClick={() =>
              setCurrentIndex(Math.min(currentIndex + 1, records.length - 1))
            }
            disabled={currentIndex === records.length - 1}
          >
            Siguiente
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ModalCleaningHistory;
